export class PasswordSwitcher {
  static start() {
    const $elements = $('.password-switcher');

    if ($elements) {
      $elements.each(function init_password_switchers() {
        const $element = $(this);

        $element.data('passwordswitcher', new PasswordSwitcher($element));
      });
    }
  }

  constructor($element) {
    this.$element = $element;
    this.$target = $element.children('input[type="password"]');
    this.$icon = $element.find('.password-switcher-icon');

    if (this.$target) this.bind_events();
  }

  bind_events() {
    this.$element.on('click', '.input-group-text', (event) => this.action_click(event));
  }

  action_click() {
    if (this.$target.attr('type') === 'password') {
      this.$target.attr('type', 'text');
      this.$icon.removeClass('fa-eye-slash');
      this.$icon.addClass('fa-eye');
    }
    else {
      this.$target.attr('type', 'password');
      this.$icon.removeClass('fa-eye');
      this.$icon.addClass('fa-eye-slash');
    }
  }
}
